new Vue({
  delimiters: ['[[', ']]'], // change because vue and django using the same args 
  el: '#app_list',
  data: {
    menuFilter: false,
    listOpened: false,
    listEx: localStorage.getItem('listOrder') ? localStorage.getItem('listOrder') : localStorage.setItem('listOrder', 0),
    listExMobile: localStorage.getItem('listOrderMobile') ? localStorage.getItem('listOrderMobile') : localStorage.setItem('listOrderMobile', 0)
  },
  methods: {
    filterPrice() {
      const allFilters = document.querySelectorAll('.filter-price');
      if (allFilters) {
        allFilters.forEach(filter => {
          const fromInput = filter.querySelector('input[name="minPrice"]');
          const toInput = filter.querySelector('input[name="maxPrice"]');
          const filterButton = filter.querySelector('.filter-button');

          function controlFromInput() {
            const [from, to] = getParsed(fromInput, toInput);
            if (from > to) fromInput.value = to;
          }

          function controlToInput() {
            const [from, to] = getParsed(fromInput, toInput);
            if (from > to) toInput.value = from;
          }

          function getParsed(from, to) {
            return [parseInt(from.value, 10) || 0, parseInt(to.value, 10) || 0];
          }

          function handleFilter() {
            let from = fromInput.value;
            let to = toInput.value;
            window.location = `?lp=${from}&hp=${to}`;
          }

          fromInput.addEventListener('input', controlFromInput);
          toInput.addEventListener('input', controlToInput);
          filterButton.addEventListener('click', handleFilter);
        });
      }
    },

    changeList(list) {
      this.listEx = list;
      localStorage.setItem('listOrder', list);
    },

    changeListMobile(list) {
      this.listExMobile = list;
      this.listOpened = false;
      localStorage.setItem('listOrderMobile', list);
    }
  },

  mounted() {
    this.filterPrice();

    document.querySelectorAll('.faq-question').forEach(question => {
      question.addEventListener('click', () => {
        const answer = question.nextElementSibling;
        const plus = question.querySelector('.plus');

        if (answer.style.display === 'block') {
          answer.style.display = 'none';
          plus.textContent = '+';
        } else {
          answer.style.display = 'block';
          plus.textContent = '-';
        }
      });
    });
  },

  watch: {
    menuFilter(newValue) {
      if (newValue) {
        document.body.style.overflow = 'hidden';
      } else {
        document.body.style.removeProperty('overflow');
      }
    },
    listOpened(newValue) {
      if (newValue) {
        document.body.style.overflow = 'hidden';
      } else {
        document.body.style.removeProperty('overflow');
      }
    },
  }
});